// extracted by mini-css-extract-plugin
module.exports = {"name":"CompanyModal_name__6AL7N","sectionTitle":"CompanyModal_sectionTitle__2ISNt","Review":"CompanyModal_Review__17LiJ"};